import { module } from 'modujs';
import Accordion from 'accordion-js';

export default class extends module {
    constructor(m) {
        super(m);
        this.id = this.getData('id', this.el);
    }

    init() {
      const self = this;
      console.log('init');
      this.accordion = new Accordion(`.accordion-container-${this.id}`, {
        duration: 400,
        beforeOpen: function(currentElement) {
          self.call('closeAccordion', self.id, 'Faqgroup')
        }
      });
    }

    closeAccordion(originId) {

      if(originId !== this.id) {
        const elements = this.$('element');

        [...elements].forEach((element, idx) => {
          const isActive = element.classList.contains('is-active');
    
          if (isActive) {
            this.accordion.close(idx);
          }
        })

      }
    }

    destroy() {
      console.log('destroyed')
      this.accordion = null;
    }

    update() {
      console.log('update')
    }
}
